/* eslint-disable react/prop-types */
import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import Chat from 'components/Chat/Chat.js';


const styles = {
  cardIconTitle: {
    color: "#3C4858",
    margin: "10px 0 0",
    fontWeight: "300"
  }
};


class ChatPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      updated: false
    };
  }

  // eslint-disable-next-line no-unused-vars
  handleClick = name => event => {};

  render() {
    const user = this.props.user;

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          {user?
            <Chat
              currentUser={user.username}
            />:null
          }
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(styles)(ChatPage);
